import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import classNames from "classnames";
import Chrome from "@zendesk/knowledge-chrome/lib/Chrome";
import { ContentView, Sidebar } from "@zendesk/guide-chrome";
import t from "@zendesk/client-i18n-tools";
import { Button, Tabs } from "@zendesk/self-service-components";
import { hasFeature, getCurrentBrandId } from "@zendesk/knowledge-context";
import ErrorBoundary from "../ErrorBoundary";
import Notifications from "../Notifications";
import { getPermissionsUrl, getUserSegmentsUrl } from "utils/urls";
import List from "./components/List";
import * as actions from "../../actions/userSegment";
import styles from "./index.css";

const STAFF_TYPE = "staff";
const SIGNED_IN_TYPE = "signedIn";

export class UserSegments extends Component {
  render() {
    const {
      type,
      page,
      showSidebar,
      addUserSegment,
      filterUserSegments,
    } = this.props;

    return (
      <Chrome
        brandId={getCurrentBrandId()}
        dir={t.dir}
        topNav={
          <Chrome.Breadcrumbs>
            <Chrome.Breadcrumbs.Item>
              <a href={getUserSegmentsUrl()}>
                {t("knowledge-user-segments.userPermissions")}
              </a>
            </Chrome.Breadcrumbs.Item>
            <Chrome.Breadcrumbs.Separator />
            <Chrome.Breadcrumbs.Item>
              {t("knowledge-user-segments.name")}
            </Chrome.Breadcrumbs.Item>
          </Chrome.Breadcrumbs>
        }
      >
        {showSidebar && (
          <Sidebar>
            <Sidebar.Item active testId="sidebar-user-segments-link">
              {t("knowledge-user-segments.name")}
            </Sidebar.Item>
            <Sidebar.LinkItem
              href={getPermissionsUrl()}
              testId="sidebar-permission-groups-link"
            >
              {t("knowledge-user-segments.managementPermissions")}
            </Sidebar.LinkItem>
          </Sidebar>
        )}
        <ContentView>
          <div
            className={classNames(
              showSidebar ? styles.twoColumn : styles.singleColumn
            )}
          >
            <ErrorBoundary>
              <Notifications />
              <div className={styles.header}>
                <div className={styles.headerContent}>
                  <h1 className={styles.title}>
                    {t("knowledge-user-segments.list.title")}
                  </h1>
                  <p
                    className={styles.subtitle}
                    dangerouslySetInnerHTML={{
                      __html: t("knowledge-user-segments.list.description", {
                        learnMoreUrl: t(
                          "knowledge-user-segments.list.descriptionLearnMoreUrl"
                        ),
                      }),
                    }}
                  />
                </div>
                <Button
                  type="primary"
                  onClick={addUserSegment}
                  testId="add-new"
                >
                  {t("knowledge-user-segments.list.addNew")}
                </Button>
              </div>

              <Tabs active={type} onChange={filterUserSegments}>
                <Tabs.Panel
                  label={t("knowledge-user-segments.list.tabStaff")}
                  id={STAFF_TYPE}
                  testId="tab-staff"
                >
                  <List key={STAFF_TYPE} type={STAFF_TYPE} page={page} />
                </Tabs.Panel>

                <Tabs.Panel
                  label={t("knowledge-user-segments.list.tabSignedInUsers")}
                  id={SIGNED_IN_TYPE}
                  testId="tab-signed-in-users"
                >
                  <List
                    key={SIGNED_IN_TYPE}
                    type={SIGNED_IN_TYPE}
                    page={page}
                  />
                </Tabs.Panel>
              </Tabs>
            </ErrorBoundary>
          </div>
        </ContentView>
      </Chrome>
    );
  }
}

UserSegments.propTypes = {
  addUserSegment: PropTypes.func,
  filterUserSegments: PropTypes.func,
  type: PropTypes.oneOf([STAFF_TYPE, SIGNED_IN_TYPE]).isRequired,
  page: PropTypes.number,
  showSidebar: PropTypes.bool.isRequired,
};

UserSegments.defaultProps = {
  type: STAFF_TYPE,
  page: 1,
  showSidebar: false,
};

const mapStateToProps = ({ staffUserSegments }, { match }) => {
  const page = parseInt(match.params.page, 10);

  return {
    showSidebar:
      hasFeature("guide_permission_groups") && hasFeature("permission_groups"),
    type: match.params.type,
    page: isNaN(page) ? 1 : page,
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...actions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UserSegments);



// WEBPACK FOOTER //
// ./src/components/UserSegments/index.js